import { render, staticRenderFns } from "./QRCodeContent.vue?vue&type=template&id=83ef9b7a&scoped=true&"
import script from "./QRCodeContent.vue?vue&type=script&lang=js&"
export * from "./QRCodeContent.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeContent.vue?vue&type=style&index=0&id=83ef9b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ef9b7a",
  null
  
)

export default component.exports